import { isMobile, createCookie, eraseCookie, handleVideo } from "./helper";
import SiteHeader from "./siteHeader";
import { toggleMenu, addSticky, closeMenu } from "./navigation";
import $ from "jquery";

window.addEventListener("load", () => {
  new SiteHeader();

  const videos = document.querySelectorAll('.video-container');

  if (videos.length) {
    videos.forEach(video => handleVideo(video));
  }

  toggleMenu();

  if (isMobile()) {
    addSticky();
    //closeMenu();
  }
});

window.onresize = () => {
  if (isMobile()) {
    //closeMenu();
    addSticky();
  }
};
